const users = {
  name: 'users',
  path: 'users',
  component: resolve => require(['../../../pages/custom/users'], resolve)
}

export default users
